import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "settings-nav-elements",
  templateUrl: "./settings-nav-elements.component.html",
  styleUrls: ["./settings-nav-elements.component.scss"],
})
export class SettingsNavElementsComponent implements OnInit {
  @Input() navElement;
  @Output() navElementEvent = new EventEmitter();

  partialImagePath: string = "../../assets/images/";

  constructor() {}

  ngOnInit() {}

  getFullImagePath(navElement) {
    if (navElement.selected) {
      return this.partialImagePath + navElement.icon + "-selected.svg";
    } else {
      return this.partialImagePath + navElement.icon + ".svg";
    }
  }

  elementClicked(element) {
    this.navElementEvent.emit(element);
  }
}
